import { Component, Injector, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DialogConfig } from '../../../base/components/dialog/dialog-config';
import { UiEngineComponent } from '../../../base/components/ui-engine/ui-engine.component';

@Component({
    selector: 'kx-extended-search-component',
    templateUrl: '../../../base/components/ui-engine/ui-engine.component.html',
    styleUrls: ['../../../base/components/ui-engine/ui-engine.component.scss'],
    standalone: false
})
export class ExtendedSearchComponentComponent extends UiEngineComponent {
  resourcedef: any
  constructor(public injector: Injector,
    public smartModal: BsModalService,
    public router: Router,
    public route: ActivatedRoute,
    public dialogConfig: DialogConfig) {
    super(injector, router, route, smartModal)
  }

  ngOnInit(): void {
    this.resourcename = this.baseService.route._routerState.snapshot.url.includes('add_ivf_patient') ? 'add_ivf_patient' : this.baseService._resourceName; // get current resource name
    super.ngOnInit()
  }


  ngAfterViewChecked() {
    this.baseService._currentTitle = "" // OverLoaded page title for ui engine
  }

  selectedItemsData(event) {
    if (this._currentData.addButton && this._currentData.addButton.noOfEntries != undefined && this._currentData.addButton.noOfEntries < event.length) { { this.alerts.error(this._currentData.addButton.errMessageEntries); return } }
    let data = this._currentData.filterList;
    if (data != undefined) {
      if (this._currentData.filterList.find(x => x.id === event[0].id)) { this.alerts.error(this._currentData.addButton.commonMessage); return }
      if (this._currentData.addButton && (this._currentData.addButton.noOfEntries < this._currentData.filterList.length + 1)) { this.alerts.error(this._currentData.addButton.errMessageEntries); return }
      let finalData = data.concat(event);
      let listResource: any = {};
      listResource.count = finalData.length;
      listResource.resource = finalData;
      this._currentData.dataList = listResource;
      this._currentData.filterList = finalData;
      this._currentData.showAddButton = true;
      this._currentData.dataGridConfig.hideSearchBox = true;
    }
  }

  pageChanges(event, resource?, application?, type?) {
    this._currentData.gridData.currentBtnVal = '';
    this._currentData.gridData.page_no = event - 1;
    this.updatePageInUrl(this._currentData.gridData.page_no , true);
    if (this._currentData.resouceDef.list.hasOwnProperty('APIresource')) {
      this.bindGrid(this._currentData.APIresource.resource, this._currentData.APIresource.application, '', this._currentData.APIresource.query_id);
    } else {
      this.bindGrid(resource, application, type);
    }
  }

  confirmResource(item, action) {
    let data = item;
    if(action.keytoPass){
      data = {};
      action.keytoPass.split(",").forEach((element:any)=>{
        if(element){
          data[element] = item[element]
        }
      })
    }
    super.confirmResource(data,action);
  }




  


}
